import * as React from 'react'
import { Link} from 'gatsby-plugin-react-i18next';
import './box.css'

/*Input

title
description

*/

const BoxInfo = props => {

    return (

      <div className='box'>
        <div className='container'/>

        <div className='container'>
          <h4>{props.title}</h4>
          <p>{props.description}</p>

        </div>
       
    
      </div>
    );
  };
  
export default BoxInfo;